import {
  CommonCriteria,
  PageRequest,
  PaginationResponseType,
  ResponseType,
  ShowroomType,
} from '@/types';
import { axios, get, post, put } from './baseAxios';
import { API_SHOWROOM } from './urls';

const url = API_SHOWROOM;

const create = (request: ShowroomType): Promise<ResponseType<ShowroomType>> =>
  post(`${url}`, request);

const update = (id: number, request: ShowroomType): Promise<ResponseType<ShowroomType>> =>
  put(`${url}/${id}`, request);

const deleteById = (id: number): Promise<ResponseType<boolean>> => axios.delete(`${url}/${id}`);

const getById = (id: number): Promise<ResponseType<ShowroomType>> => get(`${url}/${id}`);

const filter = (
  request: PageRequest & CommonCriteria
): Promise<PaginationResponseType<ShowroomType[]>> => get(`${url}`, { params: { ...request } });

const publish = (request: ShowroomType): Promise<ResponseType<ShowroomType>> =>
  put(`${url}/${request.id}/published`, request);

const mapVisualizations = (request: ShowroomType): Promise<ResponseType<ShowroomType>> =>
  post(`${url}/visualizations`, request);

const mapProducts = (request: ShowroomType): Promise<ResponseType<ShowroomType>> =>
  post(`${url}/products`, request);

const updateDefaultShowroom = (request: ShowroomType): Promise<ResponseType<ShowroomType>> =>
  put(`${url}/${request.id}/default`, request);

export {
  create,
  deleteById,
  filter,
  getById,
  publish,
  update,
  mapVisualizations,
  mapProducts,
  updateDefaultShowroom,
};
